import * as React from 'react'
import ReadService from "../../service/read";
import Wait from "../wait";

export default class DataProcessingPane extends React.Component {

    static self

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            show_actions: this.props.can_edit ? 'table-cell' : 'none'
        }
        DataProcessingPane.self = this
    }

    componentDidMount() {
        DataProcessingPane.loadData()
    }


    render() {
        const fontFamily = 'Poppins, Inter, Open Sans, Helvetica, Arial, sans-serif';
        
        const container = {
            width: '100%',
            minHeight: '100vh',
            background: '#f6f8fa',
            fontFamily,
            padding: '0 24px 24px 24px'
        };
        
        const header = {
            padding: '18px 0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            fontSize: 18,
            fontWeight: 700,
            color: '#395d9a',
            fontFamily,
            borderBottom: '1px solid #e0e7ef',
            marginBottom: '24px'
        };
        
        const actionBar = {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '24px'
        };
        
        const addBtn = {
            background: 'linear-gradient(90deg, #2bbbad 0%, #395d9a 100%)',
            color: 'white',
            border: 'none',
            borderRadius: 8,
            padding: '12px 24px',
            fontWeight: 600,
            fontSize: 14,
            cursor: 'pointer',
            fontFamily,
            display: 'flex',
            alignItems: 'center',
            gap: 8
        };
        
        const statsCard = {
            background: '#fff',
            borderRadius: 14,
            boxShadow: '0 4px 12px rgba(57,93,154,0.12), 0 2px 4px rgba(57,93,154,0.08)',
            padding: '20px',
            fontFamily,
            marginBottom: '24px',
            border: '1px solid rgba(57,93,154,0.05)'
        };
        
        const statsGrid = {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '20px'
        };
        
        const statItem = {
            textAlign: 'center',
            padding: '16px',
            borderRadius: '12px',
            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
            border: '1px solid #e0e7ef'
        };
        
        const statNumber = {
            fontSize: '24px',
            fontWeight: '700',
            color: '#395d9a',
            marginBottom: '4px'
        };
        
        const statLabel = {
            fontSize: '14px',
            color: '#666',
            fontWeight: '500'
        };
        
        const usersCard = {
            background: '#fff',
            borderRadius: 14,
            boxShadow: '0 4px 12px rgba(57,93,154,0.12), 0 2px 4px rgba(57,93,154,0.08)',
            padding: '24px',
            fontFamily,
            border: '1px solid rgba(57,93,154,0.05)'
        };
        
        const cardHeader = {
            fontSize: 16,
            fontWeight: 600,
            color: '#395d9a',
            marginBottom: '20px',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            paddingBottom: '12px',
            borderBottom: '2px solid #f0f0f0'
        };
        
        const userGrid = {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
            gap: '16px'
        };
        
        const userCard = {
            background: '#f8f9fa',
            borderRadius: '12px',
            padding: '16px',
            border: '1px solid #e0e7ef',
            transition: 'transform 0.2s, box-shadow 0.2s',
            cursor: 'pointer'
        };
        
        const userHeader = {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '12px'
        };
        
        const userInfo = {
            flex: 1
        };
        
        const userName = {
            fontSize: '16px',
            fontWeight: '600',
            color: '#395d9a',
            marginBottom: '4px'
        };
        
        const userRole = {
            fontSize: '14px',
            color: '#666',
            fontWeight: '500'
        };
        
        const userDetails = {
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            marginBottom: '12px'
        };
        
        const detailRow = {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '13px',
            color: '#666'
        };
        
        const statusBadge = {
            padding: '4px 8px',
            borderRadius: '12px',
            fontSize: '11px',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
        };
        
        const actionButtons = {
            display: 'flex',
            gap: '8px',
            justifyContent: 'flex-end'
        };
        
        const actionBtn = {
            background: 'none',
            border: '1px solid #e0e7ef',
            borderRadius: '6px',
            padding: '6px 8px',
            cursor: 'pointer',
            fontSize: '12px',
            color: '#666',
            transition: 'all 0.2s'
        };
        
        const emptyState = {
            textAlign: 'center',
            color: '#999',
            fontSize: '14px',
            fontStyle: 'italic',
            padding: '40px 20px'
        };
        
        return (
            <div style={container}>
                <div style={header}>
                    <span>
                        <span className={'fa fa-users'} style={{marginRight: 12}}/>
                        Registered Users
                    </span>
                    <span style={{fontSize: 14, color: '#666', fontWeight: 400}}>
                        <span className={'fa fa-history'} style={{marginRight: 8}}/>
                        Updated 28 Minutes Ago
                    </span>
                </div>

                <div style={actionBar}>
                    <div style={{display: 'flex', gap: 16, alignItems: 'center'}}>
                        <span style={{fontSize: 14, color: '#666'}}>
                            Total Users: <strong style={{color: '#395d9a'}}>{this.state.data.length}</strong>
                        </span>
                    </div>
                    <button style={addBtn}>
                        <span className={'fa fa-plus'}/>Add New User
                    </button>
                </div>
                
                <div style={statsCard}>
                    <div style={cardHeader}>
                        <span className={'fa fa-chart-bar'} style={{color: '#395d9a'}}/>
                        User Statistics
                    </div>
                    <div style={statsGrid}>
                        <div style={statItem}>
                            <div style={statNumber}>{this.state.data.length}</div>
                            <div style={statLabel}>Total Users</div>
                        </div>
                        <div style={statItem}>
                            <div style={statNumber}>{this.state.data.filter(u => u.is_active === 'Yes').length}</div>
                            <div style={statLabel}>Active Users</div>
                        </div>
                        <div style={statItem}>
                            <div style={statNumber}>{this.state.data.filter(u => u.is_active === 'No').length}</div>
                            <div style={statLabel}>Inactive Users</div>
                        </div>
                        <div style={statItem}>
                            <div style={statNumber}>{new Set(this.state.data.map(u => u.role)).size}</div>
                            <div style={statLabel}>Unique Roles</div>
                        </div>
                    </div>
                </div>
                
                <div style={usersCard}>
                    <div style={cardHeader}>
                        <span className={'fa fa-user-friends'} style={{color: '#395d9a'}}/>
                        User List
                    </div>
                    
                    {this.state.data.length > 0 ? (
                        <div style={userGrid}>
                            {this.state.data.map((user, i) => (
                                <div key={i} style={userCard}>
                                    <div style={userHeader}>
                                        <div style={userInfo}>
                                            <div style={userName}>{user.fullname}</div>
                                            <div style={userRole}>{user.role}</div>
                                        </div>
                                        <span style={{
                                            ...statusBadge,
                                            backgroundColor: user.is_active === 'Yes' ? '#d4edda' : '#f8d7da',
                                            color: user.is_active === 'Yes' ? '#155724' : '#721c24'
                                        }}>
                                            {user.is_active === 'Yes' ? 'Active' : 'Inactive'}
                                        </span>
                                    </div>
                                    
                                    <div style={userDetails}>
                                        <div style={detailRow}>
                                            <span className={'fa fa-building'} style={{color: '#666', fontSize: 12}}/>
                                            {user.office}
                                        </div>
                                        <div style={detailRow}>
                                            <span className={'fa fa-briefcase'} style={{color: '#666', fontSize: 12}}/>
                                            {user.profession}
                                        </div>
                                    </div>
                                    
                                    {this.state.show_actions === 'table-cell' && (
                                        <div style={actionButtons}>
                                            <button 
                                                style={actionBtn}
                                                onMouseOver={(e) => {
                                                    e.target.style.background = '#e3f2fd';
                                                    e.target.style.color = '#1976d2';
                                                }}
                                                onMouseOut={(e) => {
                                                    e.target.style.background = 'none';
                                                    e.target.style.color = '#666';
                                                }}
                                            >
                                                <span className={'fa fa-edit'}/>
                                    </button>
                                            <button 
                                                style={actionBtn}
                                                onMouseOver={(e) => {
                                                    e.target.style.background = '#ffebee';
                                                    e.target.style.color = '#d32f2f';
                                                }}
                                                onMouseOut={(e) => {
                                                    e.target.style.background = 'none';
                                                    e.target.style.color = '#666';
                                                }}
                                            >
                                                <span className={'fa fa-trash'}/>
                                    </button>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div style={emptyState}>
                            <span className={'fa fa-users'} style={{fontSize: 48, marginBottom: 16, opacity: 0.3}}/>
                            <p>No users found</p>
                        </div>
                    )}
                </div>
            </div>
        )
    }


    static loadData() {
        try {
            Wait.show('Fetching Data....')
            ReadService.fetchUsers().then(r=>{
                Wait.dismiss()

            })
        }catch (e) {

        }
    }
}
